import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class IntroService {
    public introFinished = signal(false);
}
